/**
 * Permission Entity
 * Represents a permission in the RBAC system
 */
export interface PermissionProps {
    permissionId: string;
    name: string;
    resource: string;
    action: string;
    description: string;
    createdAt: Date;
    updatedAt: Date;
}

export class Permission {
    private constructor(private readonly props: PermissionProps) { }

    static create(props: PermissionProps): Permission {
        return new Permission(props);
    }

    get permissionId(): string {
        return this.props.permissionId;
    }

    get name(): string {
        return this.props.name;
    }

    get resource(): string {
        return this.props.resource;
    }

    get action(): string {
        return this.props.action;
    }

    get description(): string {
        return this.props.description;
    }

    get createdAt(): Date {
        return this.props.createdAt;
    }

    get updatedAt(): Date {
        return this.props.updatedAt;
    }

    toJSON(): PermissionProps {
        return { ...this.props };
    }
}
